// @flow
import type { Node } from 'react';
import React from 'react';
import { connect } from 'react-redux';
import i18n from 'i18n-js';

import {
  MdDirections,
  MdEvent,
  MdGroup,
  MdAssignment,
  MdDirectionsRun,
  MdDirectionsBus,
} from 'react-icons/lib/md';

// import * as selectors from '../../reducers';
import * as changeStopRequestActions from '../../actions/changeStopRequests';
import BackendSidebarLink from './BackendSidebarLink';
import BackendSidebarEventsLink from './BackendSidebarEventsLink';
import styles from './backendSidebar.css';


type BackendSidebarContainerPropTypes = {
  children: Node
};

class BackendSidebarDummy extends React.Component<BackendSidebarContainerPropTypes> {
  componentDidMount() {
    const { fetchChangeStopCount } = this.props;
    fetchChangeStopCount();
  }

  render() {
    const { children } = this.props;
    return (
      <div className={styles.sidebar}>
        { children }
      </div>
    );
  }
}

export const BackendSidebarContainer = connect(
  undefined,
  dispatch => ({
    fetchChangeStopCount() {
      dispatch(changeStopRequestActions.fetchChangeStopCounter());
    }
  })
)(BackendSidebarDummy);


const Sidebar = () => (
  <BackendSidebarContainer>
    <BackendSidebarEventsLink
      Icon={MdEvent}
      to="/admin/backend/events"
      title={i18n.t('common.changeStopRequest', { count: 2 })}
      isActive={(match, { pathname }) => match || pathname === '/admin/backend'}
    />
    <BackendSidebarLink
      Icon={MdDirections}
      to="/admin/backend/routes"
      title={i18n.t('common.routesAndStops')}
    />
    <BackendSidebarLink
      Icon={MdGroup}
      to="/admin/backend/users"
      title={i18n.t('common.user', { count: 2 })}
    />
    <BackendSidebarLink
      Icon={MdDirectionsBus}
      to="/admin/backend/buses"
      title={i18n.t('common.bus', { count: 2 })}
    />
    <BackendSidebarLink
      Icon={MdDirectionsRun}
      to="/admin/backend/exit-methods"
      title={i18n.t('common.gateway', { count: 2 })}
    />
    <BackendSidebarLink
      Icon={MdAssignment}
      to="/admin/backend/reports"
      title={i18n.t('common.reports')}
    />
  </BackendSidebarContainer>
);

export default Sidebar;



// WEBPACK FOOTER //
// ./src/scripts/components/BackendSidebar/index.jsx